<template>
  <BaseAttachmentList
    :attachments="attachments"
    :loading="loading"
  >
    <template #actions>
      <ProjectAttachmentForm :id="id" />
    </template>
  </BaseAttachmentList>
</template>

<script>
import ProjectAttachmentForm from "./ProjectAttachmentForm";
import BaseAttachmentList from "../Attachments/BaseAttachmentList";
export default {
  name: "ProjectAttachmentList",
  components: {BaseAttachmentList, ProjectAttachmentForm },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    attachments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      id: this.$route.params.id
    };
  }
};
</script>
